<template>
    <v-app id="inspire">
        <v-navigation-drawer
                fixed
                v-model="drawer"
                app
        >
            <v-list dense>
                <v-list-tile
                  v-for="item in items"
                  :key="item.title"
                  :to="item.url"
                  @click="drawer = false"
                >
                    <v-list-tile-content>
                      <div v-if="item.has_divider"
                           style="width:100%;text-align:left;margin-left:0;height:1px;
                           border-bottom: 1px solid black; margin-bottom: 5px"></div>
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar color="primary" dark fixed app>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title>Dashboard Seguridad</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu :nudge-width="100">
                <v-toolbar-title slot="activator">
                    <span>{{ username }}</span>
                    <v-icon dark>fas fa-caret-down</v-icon>
                </v-toolbar-title>

                <v-list>
                    <v-list-tile
                      v-for="item in menu_items"
                      :key="item.title"
                      @click="logout"
                    >
                        <v-list-tile-title v-text="item.title"></v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-content>
                <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import { getJWTData } from '../common/jwt.service';

export default {
  data: () => ({
    drawer: false,
    right: null,
    menu_items: [{
      title: 'Cerrar Sesión',
      url: '/',
    }],
  }),
  computed: {
    username() {
      return getJWTData().identity;
    },
    items() {
      let data = [];
      const routes = [
        /*
        {
          title: 'Autorización De Pre-Registro',
          url: '/pre_registro',
        },
        */
        {
          title: 'Captura De Acceso',
          url: '/captura_accesos',
        },
        {
          title: 'Accesos Del Día Y Pendientes',
          url: '/accesos',
        },
        /*
        {
          title: 'Accesos Colaboradores',
          url: '/accesos_colaboradores',
        },
        */
        {
          title: 'Histórico Accesos',
          url: '/historico',
          has_divider: true,
        },
        /*
        {
          title: 'Histórico Accesos Obra',
          url: '/historico_obras',
        },
        */
        /*
        {
          title: 'Histórico Pre-Registro',
          url: '/historico_pre_registro',
        },
        */
        /*
        {
          title: 'Histórico Accesos Colaboradores',
          url: '/historico_acceso_colaboradores',
        },
        */
        {
          title: 'Residentes',
          url: '/captura_residentes',
          has_divider: true,
        },
        {
          title: 'Viviendas',
          url: '/captura_viviendas',
        },
        /*
        {
          title: 'Vehículos',
          url: '/captura_vehiculos',
        },
        */
        /*
        {
          title: 'Colaboradores',
          url: '/listado_colaboradores',
        },
        */
        /*
        {
          title: 'Asistencias',
          url: '/asistencias',
        },
        /*
        /*
        {
          title: 'Pórticos',
          url: '/porticos',
        },
        */
        {
          title: 'Avisos',
          url: '/avisos',
          has_divider: true,
        },
        {
          title: 'Objetos Perdidos',
          url: '/objetos_perdidos',
        },
        {
          title: 'Usuarios',
          url: '/usuarios',
          has_divider: true,
        },
      ];
      const rolesSOC = ['monitoristas', 'jefe_monitoristas'];
      const rolesEko = ['censo_residentes', 'admin_eko'];
      const rolesEkoReadOnly = ['atencion_residentes'];

      if (getJWTData().user_claims.role === 'admin') {
        data.push(...routes);
      }
      if (getJWTData().user_claims.role === 'accesos') {
        const allowed = ['/accesos', '/captura_accesos', '/historico', '/captura_viviendas'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'user') {
        const allowed = ['/accesos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'censo') {
        const allowed = ['/captura_residentes', '/captura_viviendas'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (rolesEkoReadOnly.includes(getJWTData().user_claims.role)) {
        const allowed = ['/captura_residentes', '/captura_viviendas'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (rolesEko.includes(getJWTData().user_claims.role)) {
        const allowed = ['/captura_residentes', '/captura_viviendas', '/avisos', '/objetos_perdidos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (rolesSOC.includes(getJWTData().user_claims.role)) {
        const allowed = ['/accesos', '/captura_accesos', '/historico', '/captura_residentes', '/captura_viviendas'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'avisos') {
        const allowed = ['/avisos', '/objetos_perdidos', '/captura_residentes', '/captura_viviendas'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      return data;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
  },
  props: {
  },
};
</script>
